<template>
  <div>
    <div class="justify-content-center">
        <div class="content">
          <div class="videoPlayer">
            <div class="videoholder" id="videoHolder"></div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import modal from './Modal.vue';
import play from './icons/play.vue';

export default {
  name: "Videofile",
  props: ['thumbnail', 'vfoid', 'episode', 'filename','asset_id'],
  components: {modal, play},
  data() {
    return {
      player: '',
      modalTriggerValue: false,
      videoPlaying: false,
      playbackUrls: {},
      source: '',
      myPlayer: '',
      playerHTML: '',
      playerData: {
        accountId: "1483464688001",
        playerId: "default"
      }
    }
  },
  created() {
    console.log('created vfoid ',this.asset_id);
  },
  mounted() {
    // fetch the playback urls
    // console.log('mounted vfoid ',this.vfoid);
    this.source = 'https://players.brightcove.net/1483464688001/default_default/index.html?videoId='+this.asset_id
    this.addPlayer();
  },

  methods : {
    modalTriggerOpenModal: function() {
      let app = this;
      app.modalTriggerValue = true;
      app.addPlayer();
    },
    modalTriggerCloseModal: function() {
      let app = this;
      app.modalTriggerValue = false;
      app.pauseVideo();
    },
    addPlayer: function() {
      let app = this;

      // Dynamically build the player video element
      // Doing this  so we don't fight with VueJS and the <video-js> of brightcove
      app.playerHTML =
          '<video-js id="myPlayerID' + '" data-video-id="' +
          app.asset_id +
          '"  data-account="' +
          app.playerData.accountId +
          '" data-player="' +
          app.playerData.playerId +
          '" data-embed="default" class="video-js" controls></video-js>';
      // Inject the player code into the DOM
      document.getElementById("videoHolder").innerHTML = app.playerHTML;

      // Add and execute the player script tag
      var s = document.createElement("script");
      s.src = "https://players.brightcove.net/" + app.playerData.accountId + "/" + app.playerData.playerId + "_default/index.min.js";
      // Add the script tag to the document
      document.body.appendChild(s);
    },
    // addPlayer: function() {
    //   let app = this;
    //
    //   // Dynamically build the player video element
    //   // Doing this  so we don't fight with VueJS and the <video-js> of brightcove
    //   app.playerHTML =
    //       '<video-js id="myPlayerID' + '" data-video-id="' +
    //       app.asset_id +
    //       '"  data-account="' +
    //       app.playerData.accountId +
    //       '" data-player="' +
    //       app.playerData.playerId +
    //       '" data-embed="default" class="video-js" controls></video-js>';
    //   // Inject the player code into the DOM
    //   document.getElementById("videoHolder").innerHTML = app.playerHTML;
    //
    //
    //   // Add and execute the player script tag
    //   var s = document.createElement("script");
    //   s.src = "https://players.brightcove.net/" + app.playerData.accountId + "/" + app.playerData.playerId + "_default/index.min.js";
    //   // Add the script tag to the document
    //   document.body.appendChild(s);
    // },
    pauseVideo: function() {
      let app = this;
      app.myPlayer = bc("myPlayerID");
      app.myPlayer.pause();
    },
    playVideo: function() {
      let app = this;
      app.myPlayer = bc("myPlayerID");
      app.myPlayer.play();
    },
  }
}
</script>
<style lang="scss">
.bmpui-ui-watermark {
  display:none;
}
.bmpui-ui-recommendation-overlay {

}
</style>
